"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _Actions = require("../../lib/constants/Actions");
var _styles = require("./styles");
const BookingRedirectDetails = _ref => {
  let {
    service,
    intl
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  const {
    provider
  } = state.context;
  const handleClick = e => {
    e.preventDefault();
    service.send({
      type: _Actions.REBOOK_DIRECT
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.bookingRedirect, {
    values: {
      stepName: intl.formatMessage(_messages.default.stepperApptTime)
    }
  })), /*#__PURE__*/_react.default.createElement(_styles.Link, {
    "data-testid": "ReviewAppt__RedirectLink",
    href: '/book/' + provider.id + '/appt-time',
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.goNow)));
};
BookingRedirectDetails.propTypes = {
  /**
   * The machine that maintains state and context for the component
   */
  service: _propTypes.default.instanceOf(_xstate.Interpreter).isRequired,
  /**
   * The intl object passed by injectIntl
   */
  intl: _propTypes.default.shape({
    formatMessage: _propTypes.default.func.isRequired
  }).isRequired
};
var _default = exports.default = (0, _intl.injectIntl)(BookingRedirectDetails);
BookingRedirectDetails.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BookingRedirectDetails",
  "props": {
    "service": {
      "description": "The machine that maintains state and context for the component",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "intl": {
      "description": "The intl object passed by injectIntl",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};